import React, { useState, useEffect } from 'react';
import { 
  Background, 
  TitleDiv,
  Subtitle, 
  Text, 
  FiftyPercent, 
  HeaderImg, 
  SplitDiv,
  MediaWrapper,
  MediaLink,
  HeaderTextWrapper,
  HeaderTextUpper,
  HeaderTextTittle,
  HeaderTextButton,
  HeaderTextButtonWrapper,
  ClickMap
} from './styles'
import DesktopMenu from '../DesktopMenu/index'
import MobileMenu from '../MobileMenu/index'
// import HeaderImgs from '../../assets/home/bacchusdrinks-pic.png'
import HeaderImgs from '../../assets/big-bubbles.png'
import FacebookIcon from '../../assets/home/facebook.svg'
import InstagramIcon from '../../assets/home/instagram.svg'
import YoutubeIcon from '../../assets/home/youtube.svg'
import { useNavigate } from "react-router-dom";
import useWindowSize from "../windowSize";
import { useTranslation } from "react-i18next";

const Header = () => {
  const navigate = useNavigate();
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu ] = useState(false);
  const { t } = useTranslation();

  const goToContact = () => {
    document.getElementById('contact-us').scrollIntoView()
  }

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <Background>
      {mobileMenu ? <MobileMenu/> : <DesktopMenu/> }
      <TitleDiv>
        <Subtitle>{t('welcomeWineWorld')}</Subtitle>
        <Text>Bacchus Drinks, {t('yourKegSupplier')}</Text>
      </TitleDiv>
      <SplitDiv>
        <FiftyPercent>
          <MediaWrapper>
            <a href="https://www.facebook.com/profile.php?id=100083863497733" target={"_blank"} rel="noreferrer" style={{margin: '10px 0', padding: '0'}}>
              <MediaLink src={FacebookIcon}/>
            </a>
            <a href="https://www.instagram.com/bacchus_drinks/" target={"_blank"} rel="noreferrer" style={{margin: '10px 0', padding: '0'}}>
              <MediaLink src={InstagramIcon}/>
            </a>
            <a href="https://www.instagram.com/bacchus_drinks/" target={"_blank"} rel="noreferrer" style={{margin: '10px 0', padding: '0'}}>
              <MediaLink src={YoutubeIcon}/>
            </a>
          </MediaWrapper>
          <HeaderTextWrapper>
            <HeaderTextUpper>{t('checkOut')}</HeaderTextUpper>
            <HeaderTextTittle>BACCHUS <span style={{color: '#d2a784'}}>DRINKS</span> </HeaderTextTittle>
            <HeaderTextButtonWrapper>
              <HeaderTextButton onClick={() => navigate('/group/675c8aa42d4c00690e760c87')}>{t('kegs')}</HeaderTextButton>
              <HeaderTextButton onClick={() => navigate('/group/675cb1e6571ccb44b8e30fe8	')}>{t('bottles')}</HeaderTextButton>
              <HeaderTextButton onClick={() => navigate('/group/675cb20d571ccb44b8e30fe9')}>Cupffee</HeaderTextButton>
              <HeaderTextButton onClick={() => navigate('/shop')}>{t('shopNow')}</HeaderTextButton>
            </HeaderTextButtonWrapper>
            <p style={{ color: '#d2a784', marginBottom: '15px' }}>{t('weTryOurBest')}<br/>{t('takeOffer')}<br/><br/>{t('pleaseContact')}</p>
            <HeaderTextButton cream onClick={goToContact}>{t('contactUs')}</HeaderTextButton>
          </HeaderTextWrapper>
        </FiftyPercent>
        <FiftyPercent>
          <HeaderImg src={HeaderImgs} usemap="#bubbles" />
          <ClickMap name="bubbles">
            <area alt="Cup of coffee" href="/group/4" style={{ display: "flex", height: '100%', width: '100%', borderRadius: '50%' }} />
          </ClickMap>
        </FiftyPercent>
      </SplitDiv>
    </Background>
  );
}

export default Header;
